import { useState } from 'react';
import type { Point, Polygon } from './gridTypes';

export interface DragInfo {
  polygonIndex: number;
  pointIndex: number;
}

export function usePolygonDrag(
  setPolygons: React.Dispatch<React.SetStateAction<Polygon[]>>
) {
  const [dragging, setDragging] = useState<DragInfo | null>(null);

  const startDrag = (polygonIndex: number, pointIndex: number) => {
    setDragging({ polygonIndex, pointIndex });
  };

  const updateDrag = (pos: Point) => {
    setPolygons((prev) => {
      if (!dragging) return prev;
      const updated = [...prev];
      const poly = { ...updated[dragging.polygonIndex] };
      const points = [...poly.points];
      points[dragging.pointIndex] = pos;

      if (poly.closed) {
        if (dragging.pointIndex === 0) {
          points[points.length - 1] = pos;
        } else if (dragging.pointIndex === points.length - 1) {
          points[0] = pos;
        }
      }

      poly.points = points;
      updated[dragging.polygonIndex] = poly;
      return updated;
    });
  };

  const endDrag = () => setDragging(null);

  return { dragging, startDrag, updateDrag, endDrag };
}
